import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Flag, { FlagGroup } from '@atlaskit/flag';
import Modal from '@atlaskit/modal-dialog';
import Page from '@atlaskit/page';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'jquery';
import 'bootstrap';
import 'popper.js';
import '@atlaskit/css-reset';

import './App.css';
// import '@fortawesome/fontawesome-free/css/all.css';

import StarterNavigation from '../components/StarterNavigation';

import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';

import { loadStores } from '../reducers/stores';
import { loadCategories } from '../reducers/categories';
import { loadKiosks } from '../reducers/kiosks';
import { loadAmenities } from '../reducers/amenities';
import { loadFloorplans } from '../reducers/floorplans';
import { loadTags } from '../reducers/tags';
import { loadUsers } from '../reducers/users';
import { loadMedias } from '../reducers/medias';
import { loadEvents } from '../reducers/events';

import moment from 'moment';

class App extends Component {
  state = {
    flags: [],
    isModalOpen: false,
  };

  static contextTypes = {
    navOpenState: PropTypes.object,
    router: PropTypes.object,
  };

  static propTypes = {
    navOpenState: PropTypes.object,
    onNavResize: PropTypes.func,
  };

  static childContextTypes = {
    showModal: PropTypes.func,
    addFlag: PropTypes.func,
  }

  getChildContext() {
    return {
      showModal: this.showModal,
      addFlag: this.addFlag,
    };
  }

  showModal = () => {
    this.setState({ isModalOpen: true });
  }

  hideModal = () => {
    this.setState({ isModalOpen: false });
  }

  addFlag = () => {
    this.setState({ flags: [{ id: Date.now() }].concat(this.state.flags) });
  }

  onFlagDismissed = (dismissedFlagId) => {
    this.setState({
      flags: this.state.flags.filter(flag => flag.id !== dismissedFlagId),
    })
  }

  componentWillMount = () => {
    if(!this.props.loggedIn){
      this.props.goToLoginPage();
      push('/login');
    }
  }

  componentDidMount = () => {
    if(localStorage.getItem(window.token)){
      if( JSON.parse(atob(localStorage.getItem(window.token).split('.')[1])).exp < parseInt(moment().format('X'), 10) ) {
        this.props.goToLogoutPage();
        push('/logout');
      } else {
        this.props.loadStores();
        this.props.loadCategories();
        this.props.loadKiosks();
        this.props.loadAmenities();
        this.props.loadFloorplans();
        this.props.loadTags();
        this.props.loadUsers();
        this.props.loadMedias();
        this.props.loadEvents();
      }
    } else {
      this.props.goToLogoutPage();
      push('/logout');
    }

  }

  render() {
    return (
      <div>
        <Page
          navigationWidth={this.context.navOpenState.width}
          navigation={<StarterNavigation onNavResize={({ width, isOpen }) => {
            this.props.onNavResize({width, isOpen});
          }} />}
        >
          {this.props.children}
        </Page>
        
        {/* <div>
          <FlagGroup onDismissed={this.onFlagDismissed}>
            {
              this.state.flags.map(flag => (
                <Flag
                  id={flag.id}
                  key={flag.id}
                  title="Flag Title"
                  description="Flag description"
                />
              ))
            }
          </FlagGroup>
          {
            this.state.isModalOpen && (
              <Modal
                heading="Candy bar"
                actions={[{ text: 'Exit candy bar', onClick: this.hideModal }]}
                onClose={this.hideModal}
              >
                <p style={{ textAlign: 'center' }}>
                  <img src="http://i.giphy.com/yidUztgRB2w2gtDwL6.gif" alt="Moar cupcakes" />
                </p>
              </Modal>
            )
          }
        </div> */}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  loggedIn: state.account.loggedIn
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      loadStores,
      loadCategories,
      loadKiosks,
      loadAmenities,
      loadFloorplans,
      loadTags,
      loadUsers,
      loadMedias,
      loadEvents,
      goToLogoutPage: () => push('/logout'),
      goToLoginPage: () => push('/login')
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/modules/App.js